import { alpha } from '@mui/material'

import makePalette, { black, white } from './util'

export default makePalette({
  action: {
    color: black,
    opacities: {
      active: 0.54,
      hover: 0.04,
      selected: 0.08,
      disabled: 0.26,
      focus: 0.12
    }
  },

  palette: {
    mode: 'light',

    text: {
      primary: alpha(black, 0.87),
      secondary: alpha(black, 0.6),
      disabled: alpha(black, 0.38)
    },

    background: {
      paper: white,
      layout: '#F5F5F5',
      navCard: white,
      default: '#FAFAFA'
    },

    // Kept subtle (Linear-style): containers separate with hairlines, not lines.
    divider: alpha(black, 0.08),

    customColors: {
      main: '#4C4E64',
      trackBg: '#F2F2F4',
      tableHeaderBg: '#F5F5F7'
    }
  }
})
